export default __webpack_public_path__ + "static/media/gallery-wip-pommel_02.160ef4e5.jpg";